import { CHECKOUT_BUTTON_CLICKED } from "@/constants/events"
import { ROUTES } from "@/constants/routes"
import { CUSTOM_BILLING_PERIOD_PARAM, posthogService, RecallButton } from "@recall/common"
import { FC } from "react"
import { ButtonProps } from "./types"
import { useUserCookie } from "@/app/hooks/useUserCookie"

export const UpgradeButton: FC<ButtonProps> = ({ billingPeriod }) => {
    const user = useUserCookie()

    const isLoggedIn = Boolean(user?.uid)
    const isPremiumUser = user?.isPremium

    const handleOpenApp = () => {
        posthogService.captureEvent(CHECKOUT_BUTTON_CLICKED)

        if (isPremiumUser) {
            window.open(ROUTES.LOGIN, "_blank")
        } else {
            window.open(
                `${ROUTES.APP_PURCHASE}?${CUSTOM_BILLING_PERIOD_PARAM}=${billingPeriod}`,
                "_blank"
            )
        }
    }

    let buttonText = "Get started"

    if (isLoggedIn) {
        buttonText = isPremiumUser ? "Open App" : "Upgrade"
    }

    return (
        <RecallButton size="large" onClick={handleOpenApp} fullWidth>
            {buttonText}
        </RecallButton>
    )
}
